// @ts-nocheck
import React, { Component } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_API_KEY } from '../../../../configs';
import InjectedCardSection from './InjectedCardSection';

const stripePromise = loadStripe(STRIPE_API_KEY);

class CardInput extends Component {
  render() {
    return (
      <Elements stripe={stripePromise}>
        <InjectedCardSection />
      </Elements>
    );
  }
}

export default CardInput;
